export class EnterpriseConnection {
    public constructor(init?: Partial<EnterpriseConnection>) {
        Object.assign(this, init);
    }
}